module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "ui-button",
    class: {
      'ui-button--live': _vm.project.live, 'ui-button--soon': _vm.project.soon || _vm.project.no_details
    },
    attrs: {
      "href": (_vm.project.live) ? _vm.project.url : '#',
      "target": "_blank"
    }
  }, [(_vm.project.live) ? _c('span', [_vm._v("See it live")]) : (_vm.project.soon) ? _c('span', [_vm._v("Soon!")]) : (_vm.project.no_details) ? _c('span', [_vm._v("Offline")]) : _c('span', [_vm._v("Screens")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-34a41962"}!./src/components/ui-button/ui-button.component.html
// module id = 156
// module chunks = 1